/**
 * 列表页的主体 数据获取代码
 */
import $ from 'jquery'
import ListPageAssign from "../components/overall/ListPageAssign";
import {addOrder} from "../utils/commons"
export default {
    mixins: [ListPageAssign],
    components: {
    },
    data() {
        return {
            lastQuery: {},
            listLoading: false,
            dataList: [],
            pageMsg: {
                pageSize: 10,
                pageNo: 1,
                totalRecords: 0
            },
        };
    },
    methods: {
        resetSearchData: function (defaultVals = null) { 
            for (const key in this.search) {
                if (Object.prototype.hasOwnProperty.call(this.search, key)) {
                    this.search[key] = "";
                }
            }
            if (defaultVals) {
                this.search = $.extend(true, this.search, defaultVals);
            }

        },
        //listKey 列表对应接口返回内容中 的字段，应对后端字段不统一
        //hasPage 列表是否含有分页进行处理
        getDataList: function (params, others = {}) {
            let { listKey = "list", hasPage = true } = others
            this.listLoading = true;
            return this.fetchDtList(params).then(
                r => {
                    console.log('rrrrrrrrrrrrrrrrrrr',r)
                    let _d = r.data.content.info;
                    if (listKey) {
                        this.dataList = _d[[listKey]];
                    } else {
                        this.dataList = _d;
                    } 

                    if (hasPage) {
                        this.pageMsg = this.pageAssign(_d);
                    }
                    this.dataList = addOrder(this.dataList)
                    console.log(this.dataList)
                    this.lastQuery = params;
                    this.listLoading = false;
                    this.loading?this.loading.close():'';
                },
                () => {
                    //console.log(er)
                    this.listLoading = false;
                }
            );
        },
        deleteSign: function (msg) {
            this.deleteDo(msg[this.fieldKey], msg[this.fieldRowName]);
        },
        // deleteDo: function (id, confirmMsg) {
        //     // const h = this.$createElement;
        //     this.$confirm(
        //         this.$store.state.settings.languageTip.delete + "<br/>" + confirmMsg,
        //         "提示",
        //         {
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning",
        //         dangerouslyUseHTMLString: true
        //         }
        //     ).then(() => {
        //         let params = {};
        //         params[this.fieldKey] = id;
        //         params["status"] = 1;
        //         this.delPut(params).then(res => {
        //         //console.log(res)
        //         this.$message({
        //             message: "删除成功!",
        //             type: "success"
        //         });
        //         this.doSearch(this.lastQuery);
        //         });
        //     });
        // },
        pageSizeChange: function (size) {
            //console.log(size)
            let _params = $.extend(true, this.lastQuery, {
                pageSize: size,
                pageNo: 1
            });
            //console.log(_params)
            this.getDataList(_params);
        },
        currentPageChange: function (index) {
            let _params = $.extend(true, this.lastQuery, {
                pageNo: index
            });
            this.getDataList(_params);
        }
    },


};